import { getValidClassNames } from '@/utils';
import { Button, IAdditionalClassNames } from '@netfront/ui-library';
import Link from 'next/link';

export const ContactBanner = ({ additionalClassNames }: IAdditionalClassNames) => {
  return (
    <div
      className={getValidClassNames({
        'bg-primary bg-banner-graphic rounded-xl p-8 md:p-12 mb-12': true,
        [String(additionalClassNames)]: Boolean(additionalClassNames),
      })}
    >
      <span className="h4">Contact</span>
      <h2 className="h2 mb-2">Need more information?</h2>
      <p className="mb-6">
        For further information or questions, email us or{' '}
        <Link className="color-black weight-800" href="/contact">
          get in touch here
        </Link>
      </p>

      <div className="flex items-center justify-end">
        <Button additionalClassNames="md:text-xl" linkButton={{ id: 'contact', url: '/contact' }} variant="tertiary" text="Contact us" />
      </div>
    </div>
  );
};
